import { useContext } from "react";
import { PrescriptionContextMemorySpace } from "../../../../contexts/epicrisis/prescriptionContext";
import { TarjetaResultadosComponent } from "./CardMobile";
import usePagination from "../hooks/usePagination";
import useDownload from "../hooks/useDownload";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";

const Mobile = () => {
  const { anterior, siguiente } = usePagination();
  const { descargar } = useDownload();

  const { activeKey, resultsTemp, total, loader, offset, setOffset } = useContext(
    PrescriptionContextMemorySpace
  );

  const itemsPerPage = 5;
  const totalPages = Math.ceil(total / itemsPerPage);

  const handlePageChange = (event, page) => {
    const newOffset = (page - 1) * itemsPerPage;
    setOffset(newOffset);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      <div
        className="separador-table-red-result"
        style={{ marginBottom: "20px" }}
      ></div>

      {!loader ? (
        <div>
          {resultsTemp?.length > 0 ? (
            <div className="mt-2">
              {resultsTemp?.map((result, i) => (
                <TarjetaResultadosComponent
                  key={i}
                  result={result}
                  eventDownload={() => descargar(result)}
                />
              ))}
            </div>
          ) : (
            <p
              className="section_hb_title"
              style={{
                fontSize: "16px",
                textAlign: "center",
                paddingBottom: "15px",
                paddingTop: "15px",
              }}
            >
              No se encontraron resultados con esas opciones de búsqueda.
              <br /> Intente con otros parámetros, o contáctese con nuestro
              equipo de{" "}
              <a
                href="mailto:soportewebhb@hbritanico.com.ar"
                className="section_hb_title"
                style={{
                  fontSize: "16px",
                  textDecoration: "underline",
                }}
              >
                Soporte
              </a>
              .
            </p>
          )}

          {total > 0 && resultsTemp.length > 0 && (
            <div className="row">
              <div className="col-12 my-3">
                <div
                  style={{
                    overflowX: 'auto',
                    display: 'flex',
                    justifyContent: 'center',
                    WebkitOverflowScrolling: 'touch',
                    scrollbarWidth: 'thin',
                    paddingBottom: '5px'
                  }}
                >
                  <Stack spacing={2}>
                    <Pagination
                      count={totalPages}
                      page={offset / itemsPerPage + 1}
                      onChange={handlePageChange}
                      showFirstButton={total > 5}
                      showLastButton={total > 5}
                      hidePrevButton={totalPages === 1}
                      hideNextButton={totalPages === 1}
                      color="primary"
                      size="small"
                      siblingCount={1}
                      boundaryCount={1}
                      sx={{
                        '& .MuiPaginationItem-root.Mui-selected': {
                          backgroundColor: '#E0E0E0', // gris claro
                          color: '#000', // texto negro
                          '&:hover': {
                            backgroundColor: '#d5d5d5',
                          },
                        },
                      }}
                    />
                  </Stack>
                </div>
              </div>
            </div>
          )}
        </div>
      ) : (
        <div
          className="text-center"
          style={{ paddingBottom: "15px", marginTop: "50px" }}
        >
          <span className="spinner-grow spinner-grow-sm"></span>
          <span className="spinner-grow spinner-grow-sm"></span>
          <span className="spinner-grow spinner-grow-sm"></span>
        </div>
      )}
    </>
  );
};

export default Mobile;